import { createSlice } from "@reduxjs/toolkit";
import { ICommonSlice } from "../../../models/ICommon";

const initialCommonState: ICommonSlice = {
  colleges: undefined,
  pageBlocks: undefined,
  userTypes: undefined,
  departments: undefined,
  notificationTypes: undefined,
  universities: undefined,
  reportFrequencies: undefined,
  reportNamesWithDescription: undefined,
  trainingcategories: undefined,
  trainingNameWithDescriptionAndDate: undefined,
  loginUsers: undefined,
  collegeDepartments: undefined,
  taskRespects: undefined,
  taskStatus: undefined,
  collegeTypes: undefined,
  portalRating: undefined,
  departmentName: undefined,
  collegeName: undefined,
  subSteps: undefined,
  feedback: undefined,
  emailBlocks: undefined,
  toMailId: undefined,
  campusSafetyToMailId: undefined,
  descriptionText: undefined,
  helpMail: undefined,
  freshmanProcessResponse: undefined,
  studentType: undefined,
  version: undefined,
  widgetPageBlocks: undefined,
  aiAgents: undefined,
  userSubRoles: undefined,
};

const commonSlice = createSlice({
  name: "common",
  initialState: initialCommonState,
  reducers: {
    setColleges: (state, action: { payload: any }) => {
      state.colleges = action.payload;
    },
    setPageBlocks: (state, action: { payload: any }) => {
      state.pageBlocks = action.payload;
    },
    setWidgetPageBlocks: (state, action: { payload: any }) => {
      state.widgetPageBlocks = action.payload;
    },
    setUserTypes: (state, action: { payload: any }) => {
      state.userTypes = action.payload;
    },
    setDepartments: (state, action: { payload: any }) => {
      state.departments = action.payload;
    },
    setNotificationTypes: (state, action: { payload: any }) => {
      state.notificationTypes = action.payload;
    },
    setUniversities: (state, action: { payload: any }) => {
      state.universities = action.payload;
    },
    setReportFrequencies: (state, action: { payload: any }) => {
      state.reportFrequencies = action.payload;
    },
    setReportNamesWithDescription: (state, action: { payload: any }) => {
      state.reportNamesWithDescription = action.payload;
    },
    setTrainingCategories: (state, action: { payload: any }) => {
      state.trainingcategories = action.payload;
    },
    setTrainingNameWithDescriptionAndDate: (
      state,
      action: { payload: any }
    ) => {
      state.trainingNameWithDescriptionAndDate = action.payload;
    },
    setLoginUsers: (state, action: { payload: any }) => {
      state.loginUsers = action.payload;
    },
    setCollegeDepartments: (state, action: { payload: any }) => {
      state.collegeDepartments = action.payload;
    },
    setTaskRespects: (state, action: { payload: any }) => {
      state.taskRespects = action.payload;
    },
    setTaskStatus: (state, action: { payload: any }) => {
      state.taskStatus = action.payload;
    },
    setCollegeTypes: (state, action: { payload: any }) => {
      state.collegeTypes = action.payload;
    },
    setPortalRating: (state, action: { payload: any }) => {
      state.portalRating = action.payload;
    },
    setDepartmentName: (state, action: { payload: any }) => {
      state.departmentName = action.payload;
    },
    setCollegeName: (state, action: { payload: any }) => {
      state.collegeName = action.payload;
    },
    setFeedback: (state, action: { payload: any }) => {
      state.collegeName = action.payload;
    },
    setSubSteps: (state, action: { payload: any }) => {
      state.subSteps = action.payload;
    },
    setEmailBlocks: (state, action: { payload: any }) => {
      state.emailBlocks = action.payload;
    },
    setToMailId: (state, action: { payload: any }) => {
      state.toMailId = action.payload;
    },
    setCampusSafetyToMailId: (state, action: { payload: any }) => {
      state.campusSafetyToMailId = action.payload;
    },
    setDescriptionText: (state, action: { payload: any }) => {
      state.descriptionText = action.payload;
    },
    setHelpMail: (state, action: { payload: any }) => {
      state.helpMail = action.payload;
    },
    setFreshmanProcessResponse: (state, action: { payload: any }) => {
      state.freshmanProcessResponse = action.payload;
    },
    setStudentType: (state, action: {payload: any}) => {
      state.studentType = action.payload;
    },
    setVersion: (state, action: {payload: any}) => {
      state.version = action.payload;
    },
    setAIAgents: (state, action: {payload: any}) => {
      state.aiAgents = action.payload;
    },
    setUserSubRoles: (state, action: {payload: any}) => {
      state.userSubRoles = action.payload;
    }
  },
});

export const {
  setColleges,
  setPageBlocks,
  setWidgetPageBlocks,
  setUserTypes,
  setCollegeTypes,
  setDepartments,
  setNotificationTypes,
  setUniversities,
  setReportFrequencies,
  setReportNamesWithDescription,
  setTrainingCategories,
  setTrainingNameWithDescriptionAndDate,
  setLoginUsers,
  setCollegeDepartments,
  setTaskRespects,
  setTaskStatus,
  setPortalRating,
  setDepartmentName,
  setSubSteps,
  setCollegeName,
  setFeedback,
  setEmailBlocks,
  setToMailId,
  setCampusSafetyToMailId,
  setDescriptionText,
  setHelpMail,
  setFreshmanProcessResponse,
  setStudentType,
  setVersion,
  setAIAgents,
  setUserSubRoles
} = commonSlice.actions;

const commonReducer = commonSlice.reducer;

export type commonState = ReturnType<typeof commonReducer>;

export default commonReducer;
